import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import './creditCard.scss';

const CreditCard = ({ customClass, children }) => {
  const uId = uuidv4();
  return (
    <div className={`credit-card-container ${customClass} `}>
      <svg className="" viewBox="0 0 408 236" width="100%" height="100%">
        <rect
          x="0"
          y="0"
          width="100%"
          height="100%"
          fill={`url(#grad${uId})`}
        ></rect>

        <defs>
          <linearGradient id={`grad${uId}`} gradientTransform="rotate(90)">
            <stop
              offset="5%"
              style={{ stopColor: 'rgba(142,48,240,1)', stopOpacity: '1' }}
            />
            <stop
              offset="95%"
              style={{ stopColor: 'rgba(72,71,232,1)', stopOpacity: '1' }}
            />
          </linearGradient>
        </defs>

        <ellipse
          transform="translate(300, -170)"
          cx="100"
          cy="80"
          rx="250"
          ry="200"
          // fill="#0606060a"
          fill="#0606060d"
        />
        <ellipse
          transform="translate(-80, 200)"
          cx="100"
          cy="130"
          rx="300"
          ry="200"
          fill="#0606060d"
        />
        <circle cx="360" cy="50" r="15" fill="#ff9800" />
        <circle cx="342" cy="50" r="15" fill="#bd0606c4" />
        <foreignObject className="" x="0" y="0" width="408" height="236">
          <div className="w-100 h-100 bg-transparent credit-card-body">
            {children}
          </div>
        </foreignObject>
      </svg>
    </div>
  );
};
CreditCard.propTypes = {
  customClass: PropTypes.string,
  children: PropTypes.node,
};
CreditCard.defaultProps = {
  customClass: '',
  children: '',
};
export default CreditCard;
